import { useAction } from "../components/ui";
import type { Me } from "../lib/api";
import { useSession } from "../lib/session";

/** What a new agency sees until a platform admin approves it (or after a rejection). */
export function AwaitingApproval({ me }: { me: Me }) {
  const { refresh } = useSession();
  const check = useAction();
  const rejected = me.tenant.approval === "rejected";

  return (
    <div className="page-head">
      <p className="label">{me.tenant.name}</p>
      {rejected ? (
        <>
          <h1 className="display">
            Not <em>approved</em>.
          </h1>
          <p className="lede">
            We couldn't approve this agency. If you think that's a mistake, get in touch with whoever told you about the
            platform.
          </p>
        </>
      ) : (
        <>
          <h1 className="display">
            Almost <em>there</em>.
          </h1>
          <p className="lede">
            We're opening the platform to agencies one at a time while it's in pilot. Your agency is waiting for approval;
            you'll be able to use everything as soon as it's through.
          </p>
          <p className="spaced-top">
            <button type="button" className="btn secondary" disabled={check.pending} onClick={() => void check.run(refresh)}>
              {check.pending ? "Checking…" : "Check again"}
            </button>
          </p>
        </>
      )}
    </div>
  );
}
